"use strict";
CompanyGdprContactNewCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  'CompanyGdprContactsService',
  '$translate',
  'growl'];

function CompanyGdprContactNewCtrl(
  $scope,
  $stateParams,
  $state,
  CompanyGdprContactsService,
  $translate,
  growl) {
  $scope.save = function(gdprContact) {
    CompanyGdprContactsService.save({companyId: $stateParams.companyId}, gdprContact, function() {
      growl.addSuccessMessage($translate.instant('gdpr.contact.save-success'));
      $state.go('root.company.account.gdpr-contacts.list');
    }, function(){
      growl.addErrorMessage($translate.instant('gdpr.contact.save-failure'));
    });
  };
}

angular.module("dokiv")
  .controller("CompanyGdprContactNewCtrl", CompanyGdprContactNewCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/gdpr/contacts/CompanyGdprContactNewCtrl.js
// module id = 357
// module chunks = 0